import List from './NotificationList'
import Sent from './NotificationSent'

const exportObj = {
    List,
    Sent
}

export default exportObj